import { Title } from "@vds/typography";
import { useEffect, useState } from "react";
import DevicesTable from "../../../global/components/Tables/DevicesTable";

import { useSelector } from "react-redux";
import { getIncidentsData } from "../../../global/utility/Utils";
import { EVENT_STATUS, SEVERITY_LEVELS } from "../../../global/constants/constants";

import GmtToLocal from "../../../global/utility/GmtToLocal";
import {
  getDeviceDetails,
  sortAndSetAlertList,
} from "../../../global/utility/tableUtils";

const CameraEvents = ({ state, cameraId, onUnresolvedEventsChange }) => {
  const itemsPerPage = 10;
  const [totalIncidents, setTotalIncidents] = useState(0);
  const [selectedPage, setSelectedPage] = useState(1);
  const [incidentList, setIncidentList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  // const [evidences, setEvidences] = useState([]);
  const { deviceList: deviceListFromReducer } = useSelector((state) => state.deviceReducer);
  const deviceList = JSON.parse(sessionStorage.getItem("deviceList")) || deviceListFromReducer || [];

  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );

  const getStreamName = (evidences) => {
    let streamName = "";
    if (Array.isArray(evidences) && evidences.length > 0) {
      deviceList.map((device) => {
        const fovId = device.id;
        const evedienceFovId =
          evidences.find((e) => e.fovId === fovId)?.fovId || "";
        if (fovId === evedienceFovId) {
          streamName = device.name;
        }
      });
    }
    return streamName;
  };

  const callIncidentsApi = async (req) => {
    setIncidentList([]);
    setTableLoading(true);
    try {
      const fetchIncidentRequestBody = {
        accountname: activeSession.accountId,
        resourceidentifier: {
          sourceid: cameraId,//state?.data?.id,
        },
        filter: {
          limitnumber: itemsPerPage,
          page: "",
          pagenumber: req?.filter?.pagenumber ?? selectedPage ,
        },
      };

      const fetchIncidentsRsp = await getIncidentsData(
        fetchIncidentRequestBody
      );

      setTotalIncidents(parseInt(fetchIncidentsRsp?.headers?.XTotalCount) ?? 0);

      let incidentList = fetchIncidentsRsp?.res ?? [];

      for (let i = 0; i < incidentList.length; i++) {
        let deviceName = getDeviceDetails(deviceList, incidentList[i].deviceid);
        let alertDetails = {};
        alertDetails.devicename = deviceName?.name;
        alertDetails.device = deviceName;
        incidentList[i].createdAt = GmtToLocal(incidentList[i].createdAt);
        incidentList[i].streamName = getStreamName(incidentList[i].evidences);
        incidentList[i] = { ...incidentList[i], ...alertDetails };
      }

      // const evidenceList = incidentList.filter(
      //   (item) =>
      //     item?.evidences &&
      //     item.evidences.length > 0 &&
      //     item.evidences.some(
      //       (evidence) => evidence.sourceId === state?.data?.refid
      //     )
      // );
      // setEvidences(evidenceList);

      setIncidentList([...sortAndSetAlertList(incidentList)]);
      
      const unresolvedEvent = incidentList.find(incident => 
        incident.status === EVENT_STATUS.UNRESOLVED && 
        (incident.priority?.toUpperCase() === SEVERITY_LEVELS.CRITICAL.toUpperCase() || incident.severity?.toUpperCase() === SEVERITY_LEVELS.CRITICAL.toUpperCase())
      );
      if (onUnresolvedEventsChange) {
        onUnresolvedEventsChange(unresolvedEvent || null);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    if (cameraId && activeSession?.accountId) {
      let req = {
        accountname: activeSession.accountId,
        filter: {
          limitnumber: itemsPerPage,
          page: "",
          pagenumber: selectedPage,
        },
      };
      callIncidentsApi(req);
    }
  }, [cameraId, activeSession?.accountId]);

  const handlePageClick = (page) => {
    setSelectedPage(page);
    let req = {
      accountname: sessionStorage.getItem("accountId"),
      filter: {
        limitnumber: itemsPerPage,
        page: "",
        pagenumber: page,
      },
    };
    callIncidentsApi(req);
  };

  return (
    <div className="camera-events__container">
      <div className="camera-events__title-wrapper">
        <Title size="medium" viewport="desktop">
          Camera Events
        </Title>
      </div>
      <div className="camera-events__table-scroll">
        <DevicesTable
          pageName="cameraEvents"
          incidentList={incidentList}
          // state={state}
          cameraId={cameraId}
          handlePageClick={handlePageClick}
          totalIncidentCount={totalIncidents}
          itemsPerPage={itemsPerPage}
          tableLoading={tableLoading}
        />
      </div>
    </div>
  );
};

export default CameraEvents;
